export const supportEmail = 'support@firestarter.finance'
export const infoEmail = 'info@firestarter.finance'
